import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './GeneralNavbar.css'; // Estilos generales para el navbar

const GeneralNavbar = ({ title, onBackClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`general-navbar ${isScrolled ? 'general-navbar-scrolled' : ''}`}>
      <div className="back-button-container" onClick={onBackClick}>
        <i className="fas fa-arrow-left back-button-icon"></i>
      </div>
      <div className="general-title-container">
        <h1 className="general-title">{title}</h1>
      </div>
    </nav>
  );
};

export default GeneralNavbar;
